<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-3">
          <label>Regime:</label>
          <select class="form-control" v-model="defaultRegime" @change="onChangeRegime">
            <option v-show="false" value="Selecione">Selecione</option>
            <option value="1">Simples Nacional</option>
            <option value="2">Lucro Presumido</option>
            <option value="3">Lucro Real</option>
          </select>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-3">
          <label>Alíq. Adicional:</label>
          <span class="form-control" :disabled="true"> {{ regimeInfo.aliqAdicional }} % </span>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label for="">Cofins:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.cofins }} % </span>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label for="">CSLL:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.csll }} % </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="">Fat Red Csll:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.fatRedCsll }} % </span>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-3">
          <label>Fat Red Irpj:</label>
          <span class="form-control" :disabled="true"> {{ regimeInfo.fatRedIrpj }} % </span>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="">Fat Red. Serviços:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.fatRedServicos }} % </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="">Impostos Folha:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.impostosFolha }} % </span>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-sm-12">
        <div class="col-sm-3">
          <div class="form-group">
            <label for="">IRPJ:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.irpj }} % </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="">Limite Lucro Mês:</label>
            <span class="form-control" :disabled="true">
              {{ regimeInfo.limiteLucroMes | currency }}
            </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="">PIS:</label>
            <span class="form-control" :disabled="true"> {{ regimeInfo.pis }} % </span>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="">Vigência:</label>
            <input-data-mes
              v-model="regimeInfo.vigencia2"
              :editable="true"
              placeholder="Vigência"
            />
          </div>
        </div>
      </div>
    </div>

    &nbsp;

    <div class="row">
      <div class="col-sm-12" style="padding-top: 10px">
        <button
          type="button"
          class="btn btn-success btn-sm pull-right"
          title="Salvar regime federal"
          @click.prevent="save"
          :disabled="emptyFields"
        >
          <i class="fa fa-save" /> Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaService from '../../services/EmpresaService'
import InputDataMes from '../../components/Inputs/InputDataMes.vue'
export default {
  name: 'modal-regime-federal',
  data() {
    return {
      idRegime: 0,
      regimeInfo: {},
      defaultRegime: 'Selecione',
      AliqAlreadyBeenSearched: false,
      vigencia: ''
    }
  },

  mounted() {
    this.getRegime().then(() => this.getAliquotasRegime({ vigencia: this.vigencia }))
  },

  methods: {
    async onChangeRegime(vl) {
      this.idRegime = this.defaultRegime
      if (this.regimeInfo.vigencia2 && !this.AliqAlreadyBeenSearched) {
        this.AliqAlreadyBeenSearched = true
        await this.getAliquotasRegime({ vigencia: this.regimeInfo.vigencia2 })
      }
    },

    async getAliquotasRegime({ vigencia }) {
      try {
        if (!this.idRegime || !vigencia) return
        const { data } = await EmpresaService.getRegimeFederal({ regime: this.idRegime, vigencia })
        this.regimeInfo = data[0]
        this.AliqAlreadyBeenSearched = true
      } catch (e) {
        this.$messages.error(e.message || e.data.message).toast('Não foi possível buscar o regime.')
        console.error(e)
      }
    },

    regimeOptions(regime) {
      const options = {
        'Simples Nacional': 1,
        'Lucro Presumido': 2,
        'Lucro Real': 3
      }
      return options[regime]
    },

    async getRegime() {
      try {
        const {
          data: [{ descricao, vigencia2 } = {}]
        } = await EmpresaService.getRegimeFederalByIdEmpresa({
          idEmpresa: this.empresaSelecionada.id
        })
        if (!descricao || !vigencia2) return
        this.vigencia = vigencia2
        this.idRegime = this.regimeOptions(descricao)
        this.defaultRegime = this.idRegime
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar o regime da empresa.')
        console.error(e)
      }
    },

    async save() {
      try {
        await EmpresaService.saveRegimeFederal(this.savePayload)
        this.$messages.success().toast('Regime alterado com sucesso.')
        this.$emit('on-save', true)
      } catch (e) {
        this.$messages.error(e.message || e.data.message).toast('Não foi possível salvar o regime.')
        console.error(e)
      }
    },

    formatDate(data) {
      return data
        ? data
          .split('T')[0]
          .split('-')
          .reverse()
          .join('/')
        : ''
    }
  },

  components: {
    InputDataMes
  },

  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    },

    savePayload() {
      return {
        idEmpresa: this.empresaSelecionada.id,
        idTipoRegime: this.idRegime,
        vigencia: this.regimeInfo.vigencia2.includes('T')
          ? this.regimeInfo.vigencia2.split('T')[0]
          : this.regimeInfo.vigencia2
      }
    },

    emptyFields() {
      return !this.idRegime || (!this.vigencia && !this.regimeInfo.vigencia2)
    }
  },

  watch: {
    'regimeInfo.vigencia2'(vl) {
      if (this.idRegime && !this.AliqAlreadyBeenSearched) {
        this.AliqAlreadyBeenSearched = true
        this.getAliquotasRegime({ vigencia: vl.split('T')[0] })
      }
    }
  }
}
</script>

<style lang="css">
.space-around {
  display: flex;
  justify-content: space-around;
}
.input-number::-webkit-outer-spin-button,
.input-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
